/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './CreditCard-ActionTypes';

export const findCreditCardBrand = (data) => ({
    type: actionTypes.FIND_CARD_BRAND,
    data,
});

export const loadCreditCardBrand = (data) => ({
    type: actionTypes.LOAD_CARD_BRAND,
    data,
});
